export class User {
    id: number;
    roleid:number;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    token: string;
    bidderno:string;
}

export class ChangePasswordModel {  
      UserId : number;
      OldPassword: string;
      NewPassword : string;
}

export class ChangeNewPasswordModel {  
    UserId : number;
    UserName: string;
    NewPassword : string;
    Token : string;
}

export class currentLocation {  
    StorageLotId : number;
    StorageLotName: string;  
}

export class DeleteBidderAccountModel {  
    BidderId : number;
}